export const prefix = 'JwtCustomizer';
/** The type of a custom JWT scenario. */
export var Type;
(function (Type) {
    Type["AccessToken"] = "AccessToken";
    Type["ClientCredentials"] = "ClientCredentials";
})(Type || (Type = {}));
